import { SelectionChip } from './SelectionChip';

export function SelectionGroup({
  name,
  pctLabel,
  description,
  dotClass,
  tint,
  items,
  selectedKeys,
  getKey,
  onToggle,
}) {
  return (
    <section>
      <div className="flex items-center gap-space-2">
        <span className={['h-[11px] w-[11px] shrink-0 rounded-ds-sm', dotClass].join(' ')} aria-hidden />
        <span className="type-body-sm font-bold text-foreground">{name}</span>
        <span className="type-chip ml-auto font-semibold text-muted-foreground/80">{pctLabel}</span>
      </div>
      <p className="type-caption mt-space-1 leading-snug text-muted-foreground">{description}</p>
      <div className="mt-space-2-5 grid grid-cols-2 gap-space-2 lg:grid-cols-3 [&>*]:min-w-0">
        {items.map((item) => {
          const key = getKey(item);
          return (
            <SelectionChip
              key={key}
              label={item.label || item.name}
              icon={item.Icon || item.icon}
              tint={item.tint || tint}
              selected={selectedKeys.has(key)}
              onToggle={() => onToggle(key, item)}
            />
          );
        })}
      </div>
    </section>
  );
}
